import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HistorialPage } from './historial.component';
import { authGuard } from '@guards/auth.guard';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'historial',
    component: HistorialPage,
    canActivate: [authGuard, hasRoleGuard(null, ['use_historial'])],
    data: {
      title: "Historial"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class HistorialPageRoutingModule { }
